import type { CollaborationType } from '../../../../../common/collaboration-types.js'

/**
 * An employee's working-capacity label for the calendar's name column
 * (TASK-535):
 *
 *  - `flex` when the *contract form* (portal_employment_records
 *    .collaboration_type) is FLEX — the same source of truth the payroll
 *    report and BalanceTime use. The shape of the working pattern is NOT a
 *    signal: Humaans encoded every part-timer's schedule as booleans
 *    (`[true×5, false×2]` + 20h/week), so a 0.5 FTE employee on a regular
 *    part-time contract would otherwise present as FLEX.
 *  - a fractional FTE (e.g. 0.5) for a part-timer.
 *  - `null` for full-time (nothing shown).
 */
export type CapacityLabel = { kind: 'flex' } | { kind: 'fte'; fte: number } | null

const FLEX_COLLABORATION_TYPE: CollaborationType = 'employment_flex'

export const resolveCapacityLabel = (input: {
    collaborationType: string | null
    fte: number | null
}): CapacityLabel => {
    if (input.collaborationType === FLEX_COLLABORATION_TYPE) return { kind: 'flex' }
    // DECIMAL columns may reach the client as strings — coerce before comparing.
    const fte = input.fte === null ? null : Number(input.fte)
    if (fte !== null && Number.isFinite(fte) && fte < 1) return { kind: 'fte', fte }
    return null
}
